import type { CreatorDetails } from '../types';
import { mapCreatorDetailsDto } from './creator.mapper';
import { fetchCreatorDetails } from './creator-api';

export async function loadCreatorDetails(): Promise<CreatorDetails> {
	return mapCreatorDetailsDto(await fetchCreatorDetails());
}
